enum ButtonSize {
    SMALL = 'small',
    DEFAULT = 'medium',
    LARGE = 'large',
}

export default ButtonSize;